const actions = {
  FETCH_RKEEPER_SETTINGS_START: 'FETCH_RKEEPER_SETTINGS_START',
  FETCH_RKEEPER_SETTINGS_SUCCESS: 'FETCH_RKEEPER_SETTINGS_SUCCESS',
  FETCH_RKEEPER_SETTINGS_FAILURE: 'FETCH_RKEEPER_SETTINGS_FAILURE',

  CREATE_RKEEPER_SETTINGS_START: 'CREATE_RKEEPER_SETTINGS_START',
  SUBMIT_RKEEPER_SETTINGS_START: 'SUBMIT_RKEEPER_SETTINGS_START',
  SUBMIT_RKEEPER_SETTINGS_SUCCESS: 'SUBMIT_RKEEPER_SETTINGS_SUCCESS',
  SUBMIT_RKEEPER_SETTINGS_FAILURE: 'SUBMIT_RKEEPER_SETTINGS_FAILURE',

  FETCH_PARTNER_SETTINGS_START: 'FETCH_PARTNER_SETTINGS_START',
  FETCH_PARTNER_SETTINGS_SUCCESS: 'FETCH_PARTNER_SETTINGS_SUCCESS',
  FETCH_PARTNER_SETTINGS_FAILURE: 'FETCH_PARTNER_SETTINGS_FAILURE',

  SUBMIT_PARTNER_SETTINGS_START: 'SUBMIT_PARTNER_SETTINGS_START',
  SUBMIT_PARTNER_SETTINGS_SUCCESS: 'SUBMIT_PARTNER_SETTINGS_SUCCESS',
  SUBMIT_PARTNER_SETTINGS_FAILURE: 'SUBMIT_PARTNER_SETTINGS_FAILURE',

  SUBMIT_PARTNER_PLAN_START: 'SUBMIT_PARTNER_PLAN_START',
  SUBMIT_PARTNER_PLAN_SUCCESS: 'SUBMIT_PARTNER_PLAN_SUCCESS',
  SUBMIT_PARTNER_PLAN_FAILURE: 'SUBMIT_PARTNER_PLAN_FAILURE',

  SUBMIT_CREATE_SITE_START: 'SUBMIT_CREATE_SITE_START',
  SUBMIT_CREATE_SITE_SUCCESS: 'SUBMIT_CREATE_SITE_SUCCESS',
  SUBMIT_CREATE_SITE_FAILURE: 'SUBMIT_CREATE_SITE_FAILURE',

  SUBMIT_CREATE_MENU_START: 'SUBMIT_CREATE_MENU_START',
  SUBMIT_CREATE_MENU_SUCCESS: 'SUBMIT_CREATE_MENU_SUCCESS',
  SUBMIT_CREATE_MENU_FAILURE: 'SUBMIT_CREATE_MENU_FAILURE',

  SUBMIT_FILL_BRAND_START: 'SUBMIT_FILL_BRAND_START',
  SUBMIT_FILL_BRAND_SUCCESS: 'SUBMIT_FILL_BRAND_SUCCESS',
  SUBMIT_FILL_BRAND_FAILURE: 'SUBMIT_FILL_BRAND_FAILURE',

  SUBMIT_SITE_ADDRESS_START: 'SUBMIT_SITE_ADDRESS_START',
  SUBMIT_SITE_ADDRESS_SUCCESS: 'SUBMIT_SITE_ADDRESS_SUCCESS',
  SUBMIT_SITE_ADDRESS_FAILURE: 'SUBMIT_SITE_ADDRESS_FAILURE',

  SUBMIT_SITE_ADDRESS_DOMAIN_START: 'SUBMIT_SITE_ADDRESS_DOMAIN_START',
  SUBMIT_SITE_ADDRESS_DOMAIN_SUCCESS: 'SUBMIT_SITE_ADDRESS_DOMAIN_SUCCESS',
  SUBMIT_SITE_ADDRESS_DOMAIN_FAILURE: 'SUBMIT_SITE_ADDRESS_DOMAIN_FAILURE',

  FETCH_BRAND_SETTINGS_START: 'FETCH_BRAND_SETTINGS_START',
  FETCH_BRAND_SETTINGS_SUCCESS: 'FETCH_BRAND_SETTINGS_SUCCESS',
  FETCH_BRAND_SETTINGS_FAILURE: 'FETCH_BRAND_SETTINGS_FAILURE',

  FETCH_IIKO_SETTINGS_START: 'FETCH_IIKO_SETTINGS_START',
  FETCH_IIKO_SETTINGS_SUCCESS: 'FETCH_IIKO_SETTINGS_SUCCESS',
  FETCH_IIKO_SETTINGS_FAILURE: 'FETCH_IIKO_SETTINGS_FAILURE',

  CREATE_IIKO_SETTINGS_START: 'CREATE_IIKO_SETTINGS_START',
  SUBMIT_IIKO_SETTINGS_START: 'SUBMIT_IIKO_SETTINGS_START',
  SUBMIT_IIKO_SETTINGS_SUCCESS: 'SUBMIT_IIKO_SETTINGS_SUCCESS',
  SUBMIT_IIKO_SETTINGS_FAILURE: 'SUBMIT_IIKO_SETTINGS_FAILURE',

  FETCH_POS_INTEGRATION_START: 'FETCH_POS_INTEGRATION_START',
  FETCH_POS_INTEGRATION_SUCCESS: 'FETCH_POS_INTEGRATION_SUCCESS',
  FETCH_POS_INTEGRATION_FAILURE: 'FETCH_POS_INTEGRATION_FAILURE',

  fetchRKeeperSettingsStart: (userId) => ({
    type: actions.FETCH_RKEEPER_SETTINGS_START,
    payload: userId,
  }),
  fetchRKeeperSettingsSuccess: (userId, rKeeperSettings) => ({
    type: actions.FETCH_RKEEPER_SETTINGS_SUCCESS,
    payload: {
      userId,
      rKeeperSettings,
    },
  }),
  fetchRKeeperSettingsFailure: (error) => ({
    type: actions.FETCH_RKEEPER_SETTINGS_FAILURE,
    payload: error,
  }),

  createRKeeperSettingsStart: (restaurantId, rKeeperSettings) => ({
    type: actions.CREATE_RKEEPER_SETTINGS_START,
    payload: {
      ...rKeeperSettings,
      restaurant_id: restaurantId,
    },
  }),
  submitRKeeperSettingsStart: (restaurantId, rKeeperSettings) => ({
    type: actions.SUBMIT_RKEEPER_SETTINGS_START,
    payload: {
      ...rKeeperSettings,
      restaurant_id: restaurantId,
    },
  }),
  submitRKeeperSettingsSuccess: (userId, rKeeperSettings) => ({
    type: actions.SUBMIT_RKEEPER_SETTINGS_SUCCESS,
    payload: {
      userId,
      rKeeperSettings,
    },
  }),
  submitRKeeperSettingsFailure: (error) => ({
    type: actions.SUBMIT_RKEEPER_SETTINGS_FAILURE,
    payload: error,
  }),

  fetchPartnerSettingsStart: (userId) => ({
    type: actions.FETCH_PARTNER_SETTINGS_START,
    payload: userId,
  }),
  fetchPartnerSettingsSuccess: (userId, partnerSettings) => ({
    type: actions.FETCH_PARTNER_SETTINGS_SUCCESS,
    payload: {
      userId,
      partnerSettings,
    },
  }),
  fetchPartnerSettingsFailure: (error) => ({
    type: actions.FETCH_PARTNER_SETTINGS_FAILURE,
    payload: error,
  }),

  submitPartnerSettingsStart: (data) => ({
    type: actions.SUBMIT_PARTNER_SETTINGS_START,
    payload: { data },
  }),
  submitPartnerSettingsSuccess: (data) => ({
    type: actions.SUBMIT_PARTNER_SETTINGS_SUCCESS,
    payload: { data },
  }),
  submitPartnerSettingsFailure: (error) => ({
    type: actions.SUBMIT_PARTNER_SETTINGS_FAILURE,
    payload: { error },
  }),

  submitPartnerPlanStart: (userId, data, stepData, history) => ({
    type: actions.SUBMIT_PARTNER_PLAN_START,
    payload: { userId, data, stepData, history },
  }),
  submitPartnerPlanSuccess: (userId, data) => ({
    type: actions.SUBMIT_PARTNER_PLAN_SUCCESS,
    payload: { userId, data },
  }),
  submitPartnerPlanFailure: (error) => ({
    type: actions.SUBMIT_PARTNER_PLAN_FAILURE,
    payload: { error },
  }),

  submitCreateSiteStart: (userId, data, stepData, history) => ({
    type: actions.SUBMIT_CREATE_SITE_START,
    payload: { userId, data, stepData, history },
  }),

  submitCreateSiteSuccess: (userId, data) => ({
    type: actions.SUBMIT_CREATE_SITE_SUCCESS,
    payload: { userId, data },
  }),

  submitCreateSiteFailure: (error) => ({
    type: actions.SUBMIT_CREATE_SITE_FAILURE,
    payload: { error },
  }),

  submitCreateMenuStart: (userId, data, stepData, history) => ({
    type: actions.SUBMIT_CREATE_MENU_START,
    payload: { userId, data, stepData, history },
  }),

  submitCreateMenuSuccess: (userId, data) => ({
    type: actions.SUBMIT_CREATE_MENU_SUCCESS,
    payload: { userId, data },
  }),

  submitCreateMenuFailure: (error) => ({
    type: actions.SUBMIT_CREATE_MENU_FAILURE,
    payload: { error },
  }),

  fetchBrandSettingsStart: (userId, restaurantId) => ({
    type: actions.FETCH_BRAND_SETTINGS_START,
    payload: { userId, restaurantId },
  }),

  fetchBrandSettingsSuccess: (userId, brandSettings) => ({
    type: actions.FETCH_BRAND_SETTINGS_SUCCESS,
    payload: { userId, brandSettings },
  }),

  submitFillBrandStart: (userId, data, stepData, history) => ({
    type: actions.SUBMIT_FILL_BRAND_START,
    payload: { userId, data, stepData, history },
  }),

  submitFillBrandSuccess: (userId, data) => ({
    type: actions.SUBMIT_FILL_BRAND_SUCCESS,
    payload: { userId, data },
  }),

  submitSiteAddressStart: (userId, data, stepData, wlData, history) => ({
    type: actions.SUBMIT_SITE_ADDRESS_START,
    payload: { userId, data, stepData, wlData, history },
  }),
  submitSiteAddressSuccess: (userId, data) => ({
    type: actions.SUBMIT_SITE_ADDRESS_SUCCESS,
    payload: { userId, data },
  }),
  submitSiteAddressFailure: (error) => ({
    type: actions.SUBMIT_SITE_ADDRESS_FAILURE,
    payload: { error },
  }),

  submitSiteAddressDomainStart: (wlData) => ({
    type: actions.SUBMIT_SITE_ADDRESS_DOMAIN_START,
    payload: { wlData },
  }),
  submitSiteAddressDomainSuccess: (userId, data) => ({
    type: actions.SUBMIT_SITE_ADDRESS_DOMAIN_SUCCESS,
    payload: { userId, data },
  }),
  submitSiteAddressDomainFailure: (error) => ({
    type: actions.SUBMIT_SITE_ADDRESS_DOMAIN_FAILURE,
    payload: { error },
  }),

  fetchIikoSettingsStart: (userId) => ({
    type: actions.FETCH_IIKO_SETTINGS_START,
    payload: userId,
  }),
  fetchIikoSettingsSuccess: (restaurantId, iikoSettings) => ({
    type: actions.FETCH_IIKO_SETTINGS_SUCCESS,
    payload: {
      restaurantId,
      iikoSettings,
    },
  }),
  fetchIikoSettingsFailure: (error) => ({
    type: actions.FETCH_IIKO_SETTINGS_FAILURE,
    payload: error,
  }),

  createIikoSettingsStart: (restaurantId, iikoSettings) => ({
    type: actions.CREATE_IIKO_SETTINGS_START,
    payload: {
      ...iikoSettings,
      restaurant_id: restaurantId,
    },
  }),
  submitIikoSettingsStart: (restaurantId, iikoSettings) => ({
    type: actions.SUBMIT_IIKO_SETTINGS_START,
    payload: {
      ...iikoSettings,
      restaurant_id: restaurantId,
    },
  }),
  submitIikoSettingsSuccess: (userId, iikoSettings) => ({
    type: actions.SUBMIT_IIKO_SETTINGS_SUCCESS,
    payload: {
      userId,
      iikoSettings,
    },
  }),
  submitIikoSettingsFailure: (error) => ({
    type: actions.SUBMIT_IIKO_SETTINGS_FAILURE,
    payload: error,
  }),

  fetchPOSIntegrationStart: (restaurantId) => ({
    type: actions.FETCH_POS_INTEGRATION_START,
    payload: restaurantId,
  }),
  fetchPOSIntegrationSuccess: (restaurantId, posIntegration) => ({
    type: actions.FETCH_POS_INTEGRATION_SUCCESS,
    payload: {
      restaurantId,
      posIntegration,
    },
  }),
  fetchPOSIntegrationFailure: (error) => ({
    type: actions.FETCH_POS_INTEGRATION_FAILURE,
    payload: error,
  }),
};
export default actions;
